module.exports = __webpack_public_path__ + "img/yellowright.24042e9f.svg";